<template lang="html">
  <div class="loginBox">
    <div class="close-btn" @click="closeLogin">×</div>
    <div class="title-a">账号登录</div>
    <!-- <a-alert v-if="callback == false" message="用户名或密码错误" type="error" showIcon  style="margin-bottom:20px;"/> -->
    <!-- <a-alert v-else="callback == true" message="成功" type="success" showIcon style="margin-bottom:20px;"/> -->
    <a-input size="large" v-model="user" placeholder="账户名" style="width:80%;margin-bottom:30px;" />
    <a-input-password v-model="passwords" size="large" placeholder="密码" style="width:80%;" />
    <div class="register" @click="register">
      注册账号
    </div>
    <a-button type="primary" style="width:80%;margin-top:20px;" @click="login">登录</a-button>
    <a-button style="width:80%;margin-top:20px;" @click="closeLogin">返回</a-button>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'

export default {
  data(){
    return{
      isShow: false,
      Register: false,
      user: '',
      passwords: '',
      callback: ''
    }
  },
  methods:{
    login(){
      // 从 localStorage 获取用户列表
      const users = JSON.parse(localStorage.getItem('users') || '[]');
      
      // 检查是否是管理员账号
      if(this.user == 'heyun' && this.passwords == 'Hy0422'){
        this.$notification['success']({
          message: '登录成功',
          description: `欢迎回来，管理员 ${this.user}`,
          duration: 2
        });
        // 保存管理员登录状态
        localStorage.setItem('isAdmin', 'true');
        localStorage.setItem('currentUser', '管理员');
        
        // 触发登录状态变化事件
        eventBus.$emit('login-status-changed');
        
        let routeUrl = this.$router.resolve({path: "/supervise"});
        window.open(routeUrl.href, '_blank');
        this.$emit('closeLogin', this.isShow);
        this.user = '';
        this.passwords = '';
        return;
      }

      // 检查普通用户
      const foundUser = users.find(u => u.username === this.user && u.password === this.passwords);
      if(foundUser) {
        this.$notification['success']({
          message: '登录成功',
          description: `欢迎回来，${this.user}`,
          duration: 2
        });
        // 保存普通用户登录状态
        localStorage.setItem('currentUser', this.user);
        localStorage.setItem('isAdmin', 'false');
        
        // 触发登录状态变化事件
        eventBus.$emit('login-status-changed');
        
        this.$emit('closeLogin', this.isShow);
        this.user = '';
        this.passwords = '';
      } else {
        this.$notification['error']({
          message: '提示',
          description: '用户名或密码错误'
        });
      }
    },
    register(){
      this.$emit('fnRegister', this.Register)
    },
    closeLogin(){
      this.$emit('closeLogin', this.isShow)
    },
  }
}
</script>

<style lang="scss" scoped>
  .loginBox{
    width: 550px;
    height: 420px;
    background: #fff;
    position: fixed;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.08);
    top: 13.7%;
    left: 34.4%;
    z-index: 101;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    padding: 30px;
    position: relative;
    .close-btn {
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 24px;
      color: #999;
      cursor: pointer;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      &:hover {
        color: #666;
      }
    }
    .title-a{
      font-size: 24px;
      color: #666666;
      margin-bottom: 30px;
    }
    .register{
      width: 80%;
      text-align: right;
      color: #1890ff;
      margin-top:30px;
      cursor: pointer;
    }
  }
</style>
